import React, { Component } from 'react';
import 'gsap/src/uncompressed/plugins/ScrollToPlugin';
import SqField from '../SqField';
import NbnSpeeds from '../NbnSpeeds';
import NbnExtras from '../NbnExtras';
import NbnOrderSummary from '../NbnOrderSummary';
import CustomLink from '../../elements/CustomLink';
import extras from '../../../../data/small-business/nbn-extras.json';
import { NO_CONTRACT, OFFER_ENDING_TEXT } from "../../constants";
import { withRouter } from "react-router-dom";
import globals from '../../globals';
import VoiceRegister from '../../modules/VoiceRegister';
import RegisterBlock from '../../modules/RegisterBlock';

class NbnPlans extends Component {

    constructor(props) {
        super(props);

        this.sceneController = null;

        this.state = {
            selectedContract: [],
            plans: [],
            selectedPlan: {},
            selectedPlanId: '',
            availableSpeed: 0,
            needToKnow: [],
            selectedExtras: [],
            extras: {},
            contractIndex: 0,
            // Totals
            monthlyTotal: 0,
            upfrontTotal: 0,
            minCharge: 0,
            isPhoneIncluded: false,
            isModemIncluded: false,
            recommendedPlan: {}
        };

        const queryString = require('query-string');
        this.urlParams = queryString.parse(this.props.location.search)
    }

    componentDidMount() {
        this.setState({
            availableSpeed: (this.props.availableSpeed ? this.props.availableSpeed : 1000)
        }, () => this.getData());
        this.props.setSqErrorMsg('Unfortunately at this time your address is not nbn&trade; ready. <a href="/small-business/nbn/register">Click here</a> to register and we will notify you when it becomes available.');
    }

    componentDidUpdate(prevProps) {
        if (prevProps.sqClass !== this.props.sqClass || prevProps.nbnMaxSpeed !== this.props.nbnMaxSpeed) {
            this.getData();
        }

        if (prevProps.availableSpeed !== this.props.availableSpeed) {
            this.setState({ availableSpeed: this.props.availableSpeed });
        }
    }

    calcMonthlyPrice(plan) {
        let price = plan.price;
        if (plan.special && plan.special.planPrice) {
            price = plan.special.planPrice;
        }
        if (this.state.isPhoneIncluded) {
            return price + 10;
        }
        return price;
    }

    calcPrice(price) {
        if (this.state.isPhoneIncluded) {
            return price + 10;
        } else {
            return price;
        }
    }

    calcTotals() {
        let monthlyTotal = 0,
            upfrontTotal = 0,
            minCharge = 0;

        if (this.state.selectedPlan) {
            monthlyTotal += this.calcMonthlyPrice(this.state.selectedPlan);

            if (this.state.isModemIncluded) {
                this.state.selectedExtras.forEach((key) => {
                    monthlyTotal += this.state.extras[key].monthlyPrice;
                    upfrontTotal += this.state.extras[key].upfrontPrice + this.state.extras[key].deliveryFee;
                });
            }

            minCharge = (monthlyTotal + upfrontTotal);
        }

        this.setState({
            monthlyTotal: monthlyTotal,
            upfrontTotal: upfrontTotal,
            minCharge: minCharge
        });
    }

    handleChangeSpeed(planId, index) {
        this.setState({
            selectedPlan: this.state.selectedContract[index],
            selectedPlanId: planId,
            contractIndex: index
        }, () => {
            this.calcTotals();
        });
    }

    handleAddToCart(extraId, event) {
        event.preventDefault();
        if (!this.state.selectedExtras.includes(extraId)) {
            const extras = [...this.state.selectedExtras, extraId];
            this.setState({
                selectedExtras: extras
            }, () => {
                this.calcTotals();
            });
        }
    }

    handleRemoveFromCart(extraId, event) {
        event.preventDefault();
        let newCart = this.state.selectedExtras.filter((i) => {
            return i !== extraId
        });
        this.setState({
            selectedExtras: newCart
        }, () => {
            this.calcTotals();
        });
        if (newCart.length === 0) {
            this.setState({isModemIncluded: false});
        }
    }

    handleSubmitOrder(event) {
        event.preventDefault();

        let cart = {
            plan_id: this.state.selectedPlanId,
            contract_term:  1,
            unlimited_phone: (this.state.isPhoneIncluded ? 1 : 0),
            payg_phone: 0,
            modem: (this.state.isModemIncluded ? (this.state.selectedExtras.includes('modem') ? 1 : 0) : 0),
            hs: 'trial',
            extender: (this.state.selectedExtras.includes('extender') ? 1 : 0),
            fdclid: ''
        };

        const planName = this.state.selectedPlan.planTitle
        const totalMinCost = this.state.minCharge
        const price = this.state.selectedPlan.special.planPrice ? this.state.selectedPlan.special.planPrice : this.state.selectedPlan.price

        globals.pushEventNbnOrderNowBusiness({ ...cart, planName, totalMinCost })
        globals.pushEventSelectItem({...cart, planName, totalMinCost, price, type: 'broadband' })

        if (this.state.selectedPlanId !== '') {
            this.props.handleSubmitOrder(cart, event);
        }
    }

    handleShowSqField(event) {
        event.preventDefault();
    }

    getData() {
        let url = `/api/getDefaultPlansSmbNbn`;
        if (this.props.sqClass && this.props.nbnMaxSpeed) {
            url = `/api/getPlansSmbNbn/${this.props.sqClass}/${this.props.nbnMaxSpeed}`;
        }

        fetch(url)
            .then(response => response.json())
            .then((response) => {
                this.setDefaultValues(response);
            });
    }

    setDefaultValues(result) {
        let contractType = NO_CONTRACT,
            defaultPlan = result[contractType],
            selectedPlanId = defaultPlan.length > 1 ? defaultPlan[1].id : defaultPlan[0].id,
            selectedPlan = defaultPlan.length > 1 ? defaultPlan[1] : defaultPlan[0]

        this.setState({
            plans: result,
            selectedContract: defaultPlan,
            selectedPlan: selectedPlan,
            selectedPlanId: selectedPlanId,
            needToKnow: result.needToKnow,
            extras: extras.extras,
            recommendedPlan: defaultPlan.length > 1 && defaultPlan[1]
        }, () => {
            this.calcTotals();
        });
    }

    handleUnlimitedSelection(value) {
        this.setState({
            isPhoneIncluded: value
        }, () => this.calcTotals());
    }

    handleModemSelection(value) {
        this.setState({
            isModemIncluded: value
        }, () => this.calcTotals());
    }

    render() {
        return <div className="nbn-plans">
            <div className="nbn-plans-inner pt-3 pt-lg-0">
              <p className="order color-indigo mt-5 mb-lg-5 mb-3">
                Type of plan
              </p>
              <div className="d-flex yes-no-container mb-5">
                <a className="items plans-btn active">
                  Business nbn™ plans
                  <div className="additional-info d-none d-lg-block">
                    Great value plans that suit most businesses
                  </div>
                </a>
                <CustomLink to="/internet/nbn-enterprise-ethernet" className="items plans-btn">
                  nbn™ Enterprise Ethernet plans
                  <div className="additional-info d-none d-lg-block">
                    Higher speed plans for bigger business
                  </div>
                </CustomLink>
              </div>
              <div className="d-lg-flex d-block contracts mb-3">
                <p className="order color-indigo mt-5 mb-3 lh">
                  Phone Line & Unlimited Business Calls
                  <br />
                  <span className="font-medium regular m-0">
                    6 months FREE voice bundle
                  </span>
                </p>
              </div>
              <div className="yes-content p-4 px-5">
                  <p>
                    Bundle a phone line with your business nbn™ plan for just an additional $10/month, and we’ll give you the additional voice bundle FREE for the first 6 months.
                    <br />
                    <br />
                    Business phone plans also include:
                    <ul className="no-style">
                      <li>- Unlimited local & national calls</li>
                      <li>- Unlimited 13 / 1300 calls</li>
                      <li>
                        - Unlimited calls to landlines in 12 international destinations: UK, New Zealand, USA, Germany, Hong Kong, Japan, France, Canada, China, Singapore, India and Croatia. <a className="underline color-indigo" href="https://www.exetel.com.au/phone/voip-international" target="_blank">
                          Other countries
                        </a> call rates will apply and are not a part of the FREE voice bundle.
                      </li>
                    </ul>
                  </p>
                </div>

              <p className="order color-indigo mt-5 mb-lg-5 mb-3" id="nbn-plan-container">
                Business nbn™ plan
              </p>
              <NbnSpeeds selectedPlan={this.state.selectedPlan} plans={this.state.selectedContract} isPhoneIncluded={this.state.isPhoneIncluded} handleChangeSpeed={this.handleChangeSpeed.bind(this)} upfrontTotal={this.state.upfrontTotal} calcMonthlyPrice={this.calcMonthlyPrice.bind(this)} calcPrice={this.calcPrice.bind(this)} recommendedPlan={this.state.recommendedPlan} />
              <div className="cis text-center mt-5 flex flex-column">
                  {OFFER_ENDING_TEXT ? <p className='m-0 pb-4 bold'>
                      {OFFER_ENDING_TEXT}
                    </p> : ''}
                <div>
                    <a className="mr-4" href={`https://files.exetel.com.au/cis/smb/nbn/2026-07/Exetel_SMB_CIS_nbn.pdf`} target="_blank">
                        Critical information summary
                    </a>
                    <a href="https://files.exetel.com.au/terms/Business_NBN_Key_Facts_Sheet.pdf" target="_blank">
                        Key fact sheet
                    </a>
                </div>
              </div>
            </div>
            <RegisterBlock isNbn />
          </div>;
    }

}

export default withRouter(NbnPlans);


// WEBPACK FOOTER //
// ./resources/assets/js/nbn/NbnPlans/NbnPlans.js